<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.bo_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="bo_yearmonth">
            <label class="weui-form-preview__label">{{customLabel.bo_yearmonth || "年月"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.bo_yearmonth
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="bo_commission">
            <label class="weui-form-preview__label">{{customLabel.bo_commission || "业绩提成"}}</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.main.bo_commission,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="bo_reward">
            <label class="weui-form-preview__label">{{customLabel.bo_reward || "奖励"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ numberFormat(form.main.bo_reward,'#,##0.00') }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="bo_otheryf">
            <label class="weui-form-preview__label">{{customLabel.bo_otheryf || "其他应发"}}</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.main.bo_otheryf,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="bo_amercement">
            <label class="weui-form-preview__label">{{customLabel.bo_amercement || "罚款"}}</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.main.bo_amercement,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="bo_otheryk">
            <label class="weui-form-preview__label">{{customLabel.bo_otheryk || "其他应扣"}}</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.main.bo_otheryk,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="bo_yfwage">
            <label class="weui-form-preview__label">{{customLabel.bo_yfwage || "应发奖金"}}</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.main.bo_yfwage,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="bo_actwage">
            <label class="weui-form-preview__label">{{customLabel.bo_actwage || "实发奖金"}}</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.main.bo_actwage,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="bo_ywage">
            <label class="weui-form-preview__label">{{customLabel.bo_ywage || "已发奖金"}}</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.main.bo_ywage,'#,##0.00') }}
              </span>
          </div>
          
          <div class="weui-form-preview__item" slot="bo_geshui">
            <label class="weui-form-preview__label">{{customLabel.bo_geshui || "个税(应扣/代扣)"}}</label>
            <span class="weui-form-preview__value">
              {{ numberFormat(form.main.bo_geshui,'#,##0.00') }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="bo_qita">
            <label class="weui-form-preview__label">{{customLabel.bo_qita || "其他(应扣/代扣)"}}</label>
            <span class="weui-form-preview__value"
              >{{ numberFormat(form.main.bo_qita,'#,##0.00') }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="bo_remark">
            <label class="weui-form-preview__label">{{customLabel.bo_remark || "备注"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.bo_remark }}
            </span>
          </div>
        </custom-layout>

      </div>
      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="(item, index) in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ index + 1 }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="bd_emcode">
              <label class="weui-form-preview__label">{{customLabel.bd_emcode || "工号"}}</label>
              <span class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.bd_emcode }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="bd_emname">
              <label class="weui-form-preview__label">{{customLabel.bd_emname || "姓名"}}</label>
              <span class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.bd_emname }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="bd_depart">
              <label class="weui-form-preview__label">{{customLabel.bd_depart || "部门"}}</label>
              <span class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.bd_depart }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="bd_orgtype">
              <label class="weui-form-preview__label">{{customLabel.bd_orgtype || "编制类型"}}</label>
              <span class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.bd_orgtype }}
              </span>
            </div>
            <template v-if="index == showIndex">
              <div class="weui-form-preview__item" slot="bd_basewage">
                <label class="weui-form-preview__label">{{customLabel.bd_basewage || "基本工资"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.bd_basewage,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="bd_postwage">
                <label class="weui-form-preview__label">{{customLabel.bd_postwage || "岗位工资"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.bd_postwage,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="bd_meritwage">
                <label class="weui-form-preview__label">{{customLabel.bd_meritwage || "绩效工资"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.bd_meritwage,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="bd_otherwage">
                <label class="weui-form-preview__label">{{customLabel.bd_otherwage || "其他"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.bd_otherwage,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="bd_coefficient">
                <label class="weui-form-preview__label">{{customLabel.bd_coefficient || "系数"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.bd_coefficient,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="bd_wage">
                <label class="weui-form-preview__label">{{customLabel.bd_wage || "合计"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.bd_wage,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="bd_commission">
                <label class="weui-form-preview__label">{{customLabel.bd_commission || "业绩提成"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.bd_commission,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="bd_reward">
                <label class="weui-form-preview__label">{{customLabel.bd_reward || "奖励"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.bd_reward,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="bd_otheryf">
                <label class="weui-form-preview__label">{{customLabel.bd_otheryf || "其他应发"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.bd_otheryf,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="bd_amercement">
                <label class="weui-form-preview__label">{{customLabel.bd_amercement || "罚款"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.bd_amercement,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="bd_otheryk">
                <label class="weui-form-preview__label">{{customLabel.bd_otheryk || "其他应扣"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.bd_otheryk,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="bd_yfwage">
                <label class="weui-form-preview__label">{{customLabel.bd_yfwage || "应发金额"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.bd_yfwage,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="bd_geshui">
                <label class="weui-form-preview__label">{{customLabel.bd_geshui || "个税(代扣)"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.bd_geshui,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="bd_qita">
                <label class="weui-form-preview__label">{{customLabel.bd_qita || "其他(代扣)"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.bd_qita,'#,##0.00') }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="bd_actwage">
                <label class="weui-form-preview__label">{{customLabel.bd_actwage || "实发金额"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ numberFormat(item.bd_actwage,'#,##0.00') }}
                </span>
              </div>
            </template>
          </custom-layout>
          <div class="weui-form-preview__item" :key="index">
            <!-- <label class="weui-form-preview__label">{{"操作"}}</label> -->
            <span class="weui-form-preview__value weui-form-preview__value-icon">
              <i class="iconfont icon-shang" v-if="index == showIndex" @click="showIndex = -1"></i>
              <i class="iconfont icon-xia" v-else @click="showIndex = index"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";

export default {
  components: {
    CustomLayout
  },
  mixins: [form],
  data() {
    return {
      baseUrl: "/api/hr/bonus",
      showIndex: -1
    };
  }
}
</script>